import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PauseCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/PauseCircleTwoTone";
import AntdIcon from "../components/AntdIcon";
var PauseCircleTwoTone = function PauseCircleTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PauseCircleTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PauseCircleTwoTone.displayName = 'PauseCircleTwoTone';
}
export default /*#__PURE__*/React.forwardRef(PauseCircleTwoTone);